import type {LocalRouteHistory} from './local-api.ts';
export type FleetHistoryResult={routes:Record<string,LocalRouteHistory>;errors:Record<string,string>;loadedAt:string};
export async function loadFleetHistory(ids:string[],read:(id:string,current:()=>boolean)=>Promise<LocalRouteHistory>,current=()=>true,onProgress=(_done:number,_total:number)=>{},concurrency=3):Promise<FleetHistoryResult>{
 const unique=[...new Set(ids)],routes:Record<string,LocalRouteHistory>={},errors:Record<string,string>={};
 let cursor=0,done=0,points=0,fatal:unknown=null;
 const active=()=>current()&&!fatal;
 const worker=async()=>{while(active()&&cursor<unique.length){const id=unique[cursor++];try{
  const route=await read(id,active);if(!active())break;
  if(!Array.isArray(route.points))throw Error('response');
  points+=route.points.length;if(points>200000)throw Error('fleet_history_too_large');
  routes[id]=route;
 }catch(error){if(!current())break;const code=error instanceof Error?error.message:'connection';
  if(['session','devicePermission','fleet_not_found','fleet_write_denied','device_not_found','fleet_history_changed','response','fleet_history_too_large'].includes(code)){fatal=error;break;}
  errors[id]=code;
 }if(active())onProgress(++done,unique.length);}};
 await Promise.all(Array.from({length:Math.min(unique.length,Math.max(1,Math.min(4,concurrency)))},worker));
 if(fatal)throw fatal;if(!current())throw Error('cancelled');
 return {routes,errors,loadedAt:new Date().toISOString()};
}
